import { createAsyncThunk } from '@reduxjs/toolkit';
import { getAllUsers } from '../../data/user-dao';
export const fetchUsersAsyncThunk = createAsyncThunk('users/fetch', async () => await getAllUsers());